const BRIEF_AUDIO_PATH = /^\/api\/brief\/audio\/([^/?#]+)$/;
export function briefAudioPath(audioUrl) {
    try {
        const url = new URL(audioUrl, "https://healthos.local");
        const match = BRIEF_AUDIO_PATH.exec(url.pathname);
        if (!match?.[1])
            return null;
        return `/api/brief/audio/${encodeURIComponent(decodeURIComponent(match[1]))}`;
    }
    catch {
        return null;
    }
}
export function createBriefPlaybackSource(opts) {
    if (!opts.audioUrl)
        return null;
    const path = briefAudioPath(opts.audioUrl);
    const uri = toAbsoluteUrl(path ?? opts.audioUrl, opts.baseUrl ?? null);
    const authorization = path && opts.token ? `Bearer ${opts.token}` : null;
    const headers = authorization ? { Authorization: authorization } : undefined;
    return {
        uri,
        sourceKey: `${uri}|${authorization ?? ""}`,
        path,
        ...(headers ? { headers } : {}),
        authenticated: Boolean(path),
    };
}
function toAbsoluteUrl(pathOrUrl, baseUrl) {
    if (/^[a-z][a-z\d+\-.]*:\/\//i.test(pathOrUrl))
        return pathOrUrl;
    return baseUrl ? `${baseUrl.replace(/\/$/, "")}${pathOrUrl}` : pathOrUrl;
}
//# sourceMappingURL=brief-playback.js.map